import React, { useState, useEffect } from "react";
import { DatePicker, Select, Button, Collapse, Spin, Alert } from "antd";
import { PlusOutlined } from '@ant-design/icons';
import { useData } from '../../contexts/DataContext';

const { Option } = Select;
const { Panel } = Collapse;
const { RangePicker } = DatePicker;

const LeftPanel = () => {
  const { sites, loading, error } = useData();
  const [selectedStation, setSelectedStation] = useState(null);
  const [availableMeasurements, setAvailableMeasurements] = useState([]);
  const [selectedMeasurement, setSelectedMeasurement] = useState(null);
  const [dateRange, setDateRange] = useState([]);

  useEffect(() => {
    if (selectedStation) {
      const station = sites.find(site => site?.id === selectedStation);
      if (station && station?.typeOfMeasurements) {
        setAvailableMeasurements(station.typeOfMeasurements.split(','));
      } else {
        setAvailableMeasurements([]);
      }
    }
  }, [selectedStation, sites]);

  const handleStationSelect = (value) => {
    setSelectedStation(value);
  };

  const handleMeasurementSelect = (value) => {
    setSelectedMeasurement(value);
  };

  const handleDateRangeChange = (dates) => {
    setDateRange(dates ? [dates[0].valueOf(), dates[1].valueOf()] : []);
  };

  const handleRawDataSubmit = () => {
    if (selectedStation && selectedMeasurement && dateRange.length === 2) {
      console.log("Fetch or display the chart series here");
    } else {
      alert("Please select a station, measurement, and date range.");
    }
  };

  if (loading) {
    return <Spin tip="Loading stations..." />;
  }

  if (error) {
    return <Alert message="Error" description="Failed to load stations." type="error" showIcon />;
  }

  return (
    <div className="p-4 bg-white rounded-lg shadow-md">
      <Collapse defaultActiveKey={['1']} >
        <Panel header="Create Chart" key="1" className="text-lg font-semibold">
          <h2 className="mt-4 mb-2 text-sm font-medium">Select Station:</h2>
          <Select 
            onChange={handleStationSelect} 
            className="w-full mb-4"
            placeholder="Select Station"
          >
            {sites.map(station => (
              <Option key={station.name} value={station?.id || station.name}>
                {station.name} - {station?.Location || "Unknown Location"}
              </Option>
            ))}
          </Select>
          <h2 className="mb-2 text-sm font-medium">Select Measurement:</h2>
          <Select 
            onChange={handleMeasurementSelect} 
            disabled={!availableMeasurements.length} 
            className="w-full mb-4"
            placeholder="Select Measurement"
          >
            {availableMeasurements.map(measurement => (
              <Option key={measurement} value={measurement}>{measurement}</Option>
            ))}
          </Select>
          <h2 className="mb-2 text-sm font-medium">Select Date Range</h2>
          <RangePicker 
            showTime 
            onChange={handleDateRangeChange} 
            className="w-full mb-4" 
          />
          <Button 
            type="primary" 
            icon={<PlusOutlined />} 
            className="w-full flex items-center justify-center space-x-2"
            onClick={handleRawDataSubmit}
          >
            <span>Display Chart Series</span>
          </Button>
        </Panel>
      </Collapse>
    </div>
  );
};

export default LeftPanel;
